import { render, staticRenderFns } from "./AfipTicketNav.vue?vue&type=template&id=048a8a2d&"
import script from "./AfipTicketNav.vue?vue&type=script&lang=js&"
export * from "./AfipTicketNav.vue?vue&type=script&lang=js&"
import style0 from "./AfipTicketNav.vue?vue&type=style&index=0&id=048a8a2d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports